import { getAddress } from "viem";
// INBOX ADDRESS
export const FACET_INBOX_ADDRESS = "0x00000000000000000000000000000000000FacE7";
// L1 MAINNET CONTRACTS
export const L1_MAINNET_ETHER_BRIDGE_CONTRACT = getAddress("0x0000000000000b07ED001607f5263D85bf28Ce4C");
// L2 MAINNET CONTRACTS
export const L2_MAINNET_BUDDY_FACTORY_CONTRACT = getAddress("0x7fEa902C73b20a73b789b8dE631E3e84fEae74f3");
// L1 SEPOLIA CONTRACTS
export const L1_SEPOLIA_ETHER_BRIDGE_CONTRACT = getAddress("0xee3ee560BA048fC844BC59f664AA084fe1B981ea");
// L2 SEPOLIA CONTRACTS
export const L2_SEPOLIA_BUDDY_FACTORY_CONTRACT = getAddress("0xC975Aa6a9eA0B76f283A4A67FD81b18158aEd598");
// COMMON L2 CONTRACTS
export const L2_L1_BLOCK_CONTRACT = getAddress("0x4200000000000000000000000000000000000015");
export const L2_WETH_CONTRACT = getAddress("0x1673540243e793b0e77c038d4a88448eff524dce");
export const CONTRACT_ADDRESSES = {
    l1: {
        mainnet: {
            ETHER_BRIDGE_CONTRACT: L1_MAINNET_ETHER_BRIDGE_CONTRACT,
        },
        sepolia: {
            ETHER_BRIDGE_CONTRACT: L1_SEPOLIA_ETHER_BRIDGE_CONTRACT,
        },
    },
    l2: {
        mainnet: {
            BUDDY_FACTORY_CONTRACT: L2_MAINNET_BUDDY_FACTORY_CONTRACT,
            L1_BLOCK_CONTRACT: L2_L1_BLOCK_CONTRACT,
            WETH_CONTRACT: L2_WETH_CONTRACT,
        },
        sepolia: {
            BUDDY_FACTORY_CONTRACT: L2_SEPOLIA_BUDDY_FACTORY_CONTRACT,
            L1_BLOCK_CONTRACT: L2_L1_BLOCK_CONTRACT,
            WETH_CONTRACT: L2_WETH_CONTRACT,
        },
    },
};
